/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
import { defineAsyncComponent } from 'vue';
import LoadingComponent from '../components/2_elements/LoadingComponent/LoadingComponent';
import BreadcrumbsBar from '../components/BreadcrumbsBar/BreadcrumbsBar';
import BusinessDevelopmentManagerCard from '../components/BusinessDevelopmentManagerCard/BusinessDevelopmentManagerCard';
import ContactUs from '../components/ContactUs/ContactUs';
import CookieDeclaration from '../components/CookieDeclaration/CookieDeclaration';
import FixedPromoMessage from '../components/FixedPromoMessage/FixedPromoMessage';
import GalleryBase from '../components/GalleryBase/GalleryBase';
import HeroBanner from '../components/HeroBanner/HeroBanner';
import HeroCarousel from '../components/HeroCarousel/HeroCarousel';
import HeroCarouselItem from '../components/HeroCarousel/HeroCarouselItem/HeroCarouselItem';
import IframeItem from '../components/IframeItem/IframeItem';
import IntroductionAdmission from '../components/IntroductionAdmission/IntroductionAdmission';
import IntroductionImage from '../components/IntroductionImage/IntroductionImage';
import IntroductionItem from '../components/IntroductionItem/IntroductionItem';
import IOrderMenu from '../components/IOrderMenu/IOrderMenu';
import MainHeader from '../components/MainHeader/MainHeader';
import MultipurposeImageBanner from '../components/MultipurposeImageBanner/MultipurposeImageBanner';
import OpenTableWidget from '../components/OpenTableWidget/OpenTableWidget';
import PromoList from '../components/PromoList/PromoList';
import PromoListItem from '../components/PromoList/PromoListItem/PromoListItem';
import PubHeroSplitBanner from '../components/PubHeroSplitBanner/PubHeroSplitBanner';
import PubInfoBar from '../components/PubInfoBar/PubInfoBar';
import RichText from '../components/RichText/RichText';
import SitemapBlock from '../components/SitemapBlock/SitemapBlock';
import SportEventList from '../components/SportEventList/SportEventList';
import SubNavigation from '../components/SubNavigation/SubNavigation';
import ThreeLevelMainHeader from '../components/ThreeLevelMainHeader/ThreeLevelMainHeader';
import VideoHeroBanner from '../components/VideoHeroBanner/VideoHeroBanner';
import BookSpaceWidget from '../components/ZoneWidgets/BookSpaceWidget/BookSpaceWidget';
import BookTableWidget from '../components/ZoneWidgets/BookTableWidget/BookTableWidget';
import HiddenRendering from '../HiddenRendering.vue';
import ErrorComponent from '../ErrorComponent.vue';

const components = new Map();
components.set('AccordionBlock', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "AccordionBlock" */ '../components/AccordionBlock/AccordionBlock.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('AccordionBlockItem', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "AccordionBlockItem" */ '../components/AccordionBlock/AccordionBlockItem/AccordionBlockItem.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('AwardsCarousel', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "AwardsCarousel" */ '../components/AwardsCarousel/AwardsCarousel.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BeerNotesFood', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BeerNotesFood" */ '../components/BeerNotes/BeerNotesFood/BeerNotesFood.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BeerNotesTasting', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BeerNotesTasting" */ '../components/BeerNotes/BeerNotesTasting/BeerNotesTasting.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BlogListing', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BlogListing" */ '../components/BlogListing/BlogListing.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BlogPost', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BlogPost" */ '../components/BlogPost/BlogPost.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BookingApp', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BookingApp" */ '../components/BookingApp/BookingApp.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BookingAppDownload', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BookingAppDownload" */ '../components/BookingApp/components/BookingAppDownload/BookingAppDownload.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BookingWidget', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BookingWidget" */ '../components/BookingWidget/BookingWidget.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BrazeBanners', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "BrazeBanners" */ '../components/BrazeBanners/BrazeBanners.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('BreadcrumbsBar', BreadcrumbsBar);
components.set('BusinessDevelopmentManagerCard', BusinessDevelopmentManagerCard);
components.set('CardCollectionStacked', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "CardCollectionStacked" */ '../components/CardCollectionStacked/CardCollectionStacked.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('ContactUs', ContactUs);
components.set('ContactWidget', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "ContactWidget" */ '../components/ContactWidget/ContactWidget.vue'), 
          })
        );
components.set('ContentCardsBlock', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "ContentCardsBlock" */ '../components/ContentCardsBlock/ContentCardsBlock.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('CookieDeclaration', CookieDeclaration);
components.set('EmbeddedForm', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "EmbeddedForm" */ '../components/EmbeddedForm/EmbeddedForm.vue'), 
          })
        );
components.set('EventCarousel', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "EventCarousel" */ '../components/EventCarousel/EventCarousel.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('EventListing', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "EventListing" */ '../components/EventListing/EventListing.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('EventListingCard', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "EventListingCard" */ '../components/EventListing/EventListingCard/EventListingCard.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('FacilitiesBlock', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "FacilitiesBlock" */ '../components/FacilitiesBlock/FacilitiesBlock.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('FeaturedPubs', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "FeaturedPubs" */ '../components/FeaturedPubs/FeaturedPubs.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('FeatureList', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "FeatureList" */ '../components/FeatureList/FeatureList.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('FixedPromoMessage', FixedPromoMessage);
components.set('FormContainer', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "FormContainer" */ '../components/FormContainer/FormContainer.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('FormElement', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "FormElement" */ '../components/FormElement/FormElement.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('GalleryBase', GalleryBase);
components.set('HeroBanner', HeroBanner);
components.set('HeroCarousel', HeroCarousel);
components.set('HeroCarouselItem', HeroCarouselItem);
components.set('IframeItem', IframeItem);
components.set('ImageGalleryPopup', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "ImageGalleryPopup" */ '../components/ImageGalleryPopup/ImageGalleryPopup.vue'), 
          })
        );
components.set('ImageTextGroup', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "ImageTextGroup" */ '../components/ImageTextGroup/ImageTextGroup.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('ImportantInformationAccordion', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "ImportantInformationAccordion" */ '../components/ImportantInformationAccordion/ImportantInformationAccordion.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('InteractiveMap', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "InteractiveMap" */ '../components/InteractiveMap/InteractiveMap.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('IntroductionAdmission', IntroductionAdmission);
components.set('IntroductionImage', IntroductionImage);
components.set('IntroductionItem', IntroductionItem);
components.set('IOrderMenu', IOrderMenu);
components.set('IOrderMenuMain', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "IOrderMenuMain" */ '../components/IOrderMenu/IOrderMenuMain.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('IOrderMenuNew', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "IOrderMenuNew" */ '../components/IOrderMenu/IOrderMenuNew.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('DownloadLinksButton', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "DownloadLinksButton" */ '../components/IOrderMenuLegacy/DownloadLinksButton/DownloadLinksButton.vue'), 
          })
        );
components.set('IOrderMenuLegacy', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "IOrderMenuLegacy" */ '../components/IOrderMenuLegacy/IOrderMenuLegacy.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('IOrderMenuMain', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "IOrderMenuMain" */ '../components/IOrderMenuLegacy/IOrderMenuMain.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('MainFooter', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "MainFooter" */ '../components/MainFooter/MainFooter.vue'),loadingComponent: LoadingComponent, 
            delay: 1000,
          })
        );
components.set('HeaderCta', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "HeaderCta" */ '../components/MainHeader/HeaderCta.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('MainHeader', MainHeader);
components.set('MenusDownload', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "MenusDownload" */ '../components/MenusDownload/MenusDownload.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('MultipurposeImageBanner', MultipurposeImageBanner);
components.set('NewsletterBlock', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "NewsletterBlock" */ '../components/NewsletterBlock/NewsletterBlock.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('OpenTableWidget', OpenTableWidget);
components.set('PromoCarousel', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "PromoCarousel" */ '../components/PromoCarousel/PromoCarousel.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('PromoCarouselItem', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "PromoCarouselItem" */ '../components/PromoCarousel/PromoCarouselItem/PromoCarouselItem.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('PromoList', PromoList);
components.set('PromoListItem', PromoListItem);
components.set('PubFacilities', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "PubFacilities" */ '../components/PubFacilities/PubFacilities.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('PubFormPopup', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "PubFormPopup" */ '../components/PubFormPopup/PubFormPopup.vue'), 
          })
        );
components.set('PubHeroSplitBanner', PubHeroSplitBanner);
components.set('PubInfoBar', PubInfoBar);
components.set('PubIntroduction', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "PubIntroduction" */ '../components/PubIntroduction/PubIntroduction.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('PubSearch', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "PubSearch" */ '../components/PubSearch/PubSearch.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('RegularEventsList', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "RegularEventsList" */ '../components/RegularEventsList/RegularEventsList.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('RelatedLinks', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "RelatedLinks" */ '../components/RelatedLinks/RelatedLinks.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('RelatedLinksItem', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "RelatedLinksItem" */ '../components/RelatedLinks/RelatedLinksItem/RelatedLinksItem.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('ReviewsBanner', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "ReviewsBanner" */ '../components/ReviewsBanner/ReviewsBanner.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('ReviewsWidget', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "ReviewsWidget" */ '../components/ReviewsWidget/ReviewsWidget.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('RichText', RichText);
components.set('SignupBanner', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "SignupBanner" */ '../components/SignupBanner/SignupBanner.vue'),loadingComponent: LoadingComponent, 
            delay: 1000,
          })
        );
components.set('SitemapBlock', SitemapBlock);
components.set('SportEventList', SportEventList);
components.set('SportEventListMain', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "SportEventListMain" */ '../components/SportEventList/SportEventListMain.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('SportHeroBanner', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "SportHeroBanner" */ '../components/SportEventList/SportHeroBanner/SportHeroBanner.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('SportHeroBannerItem', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "SportHeroBannerItem" */ '../components/SportEventList/SportHeroBannerItem/SportHeroBannerItem.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('SportsWidget', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "SportsWidget" */ '../components/SportsWidget/SportsWidget.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('StickyBookingBlock', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "StickyBookingBlock" */ '../components/StickyBookingBlock/StickyBookingBlock.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('SubNavigation', SubNavigation);
components.set('ThreeLevelMainHeader', ThreeLevelMainHeader);
components.set('VenueFinder', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "VenueFinder" */ '../components/VenueFinder/VenueFinder.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('VenueInfoModal', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "VenueInfoModal" */ '../components/VenueInfoModal/VenueInfoModal.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('VideoBase', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "VideoBase" */ '../components/VideoBase/VideoBase.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('VideoExternal', 
          defineAsyncComponent({
            loader: () => import(/* webpackChunkName: "VideoExternal" */ '../components/VideoExternal/VideoExternal.vue'), loadingComponent: LoadingComponent, delay: 0,
          })
        );
components.set('VideoHeroBanner', VideoHeroBanner);
components.set('BookSpaceWidget', BookSpaceWidget);
components.set('BookTableWidget', BookTableWidget);
components.set('Hidden Rendering', HiddenRendering);
components.set('Error Component', ErrorComponent);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
